
import { db } from '../config/firebase';
import { collection, getDocs, getDoc, doc, query, where, orderBy } from 'firebase/firestore';

export const blogService = {
    // Get all published posts
    async getPosts() {
        try {
            const postsRef = collection(db, 'blog_posts');
            const q = query(
                postsRef,
                where('isPublished', '==', true),
                orderBy('publishedAt', 'desc')
            );
            const querySnapshot = await getDocs(q);

            return querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
        } catch (error) {
            console.error("Error fetching posts:", error);
            throw error;
        }
    },

    // Get single post by slug
    async getPostBySlug(slug) {
        try {
            if (!slug) throw new Error("Slug is required");
            const docRef = doc(db, 'blog_posts', slug);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                return {
                    id: docSnap.id,
                    ...docSnap.data()
                };
            } else {
                return null; // Handle 404
            }
        } catch (error) {
            console.error("Error fetching post:", error);
            throw error;
        }
    }
};
